import React from 'react'
import { View } from 'react-native'
import { observer } from 'mobx-react-lite'
import LinearGradient from 'react-native-linear-gradient'

export const BorderGradient = observer((props: any) => {
  const { colors, borderRadius, style, children, ...rest } = props
  return (
    <LinearGradient
      colors={colors ?? ['rgba(255, 0, 255, 1)', 'rgba(145, 22, 249, 1)', 'rgba(49, 153, 255, 1)']}
      // locations={[0, 0.5, 1]}
      // useAngle
      // angle={20}
      // angleCenter={{ x: 0.5, y: 0.5 }}
      style={{
        borderRadius: borderRadius + 1,
        ...style,
      }}
      {...rest}
    >
      <View
        style={{
          borderRadius,
          // flex: 1,
          margin: 1,
          backgroundColor: '#fff',
          justifyContent: 'center',
        }}
      >
        {children}
      </View>
    </LinearGradient>
  )
})
